window.dremVars.openedSizesFilter = false;
window.dremVars.openedSortingList = true;
window.dremVars.discountsObj = {};
window.dremVars.homepageFilterArray = ['catalog', 'matrasy', 'filter'];
window.dremVars.homepageFilterLink = '';

window.k1FilterGoods = {

    isChecked: function () {
        let ids = [];
        let inputs = document.querySelectorAll('.k1-filter-checkbox-js input[type="checkbox"]');
        inputs.forEach(item => {
            if (item.checked) ids.push(item.getAttribute('id'))
        });
        return ids;
    },

    setCheckedClass: function (arr) {

        if (!arr) return false;
        const inputsTitle = document.querySelector(".k1-filter__box.razmer .k1-filter__checkbox-title");
        let tmpArr = [];
        arr.forEach(elem => {
            let input = document.querySelector(`#${elem}`);
            input.closest('.k1-filter-checkbox-js').classList.add('selected');
            if (input.closest(".razmer")) tmpArr.push(input.nextElementSibling.textContent.trim())
            let labels = document.querySelectorAll('label[for="'+ elem + '"]')
            labels.forEach(label => {
                label.closest('.k1-filter-checkbox-js').classList.add('selected')
            })

        });
        if (!inputsTitle) return;

        if (tmpArr.length) {
            let selected = BX.create("SPAN", {
                props: {
                    className: "k1-filter__checkbox-title-selected"
                },
                text: tmpArr.join(", ")
            });
            inputsTitle.querySelector("span").textContent = "Размер : ";
            inputsTitle.append(selected)
        } else {
            inputsTitle.querySelector("span").textContent = "Размер";
            if (inputsTitle.querySelector(".k1-filter__checkbox-title-selected")) {
                inputsTitle.querySelector(".k1-filter__checkbox-title-selected").remove();
            }
        }

    },

    checkOpenSize: function (button) {
        if (button) button.classList.toggle('opened');
        window.dremVars.openedSizesFilter = !window.dremVars.openedSizesFilter;
        const isOpened = window.dremVars.openedSizesFilter;
        if (isOpened) {
            if (button) {
                button.querySelector('.k1-filter__size-toggle-text').textContent = 'Выбрать другой'
            }
            this.hideAllSizes();
        } else {
            if (button) {
                button.querySelector('.k1-filter__size-toggle-text').textContent = 'Скрыть'
            }
            this.showAllSizes();
        }
    },

    showAllSizes: function () {
        let sizeBoxes = document.querySelectorAll('.k1-filter-size-box-js');
        let parentBoxes;
        if(sizeBoxes[0]){
            parentBoxes = sizeBoxes[0].closest('.k1-filter__checkboxes-body');
            parentBoxes.classList.add('opened');
        }
        sizeBoxes.forEach(box => {
            if ( box.classList.contains('recommend') ){
                box.classList.add('hidden');
            }else{
                box.classList.add('opened');
                box.classList.remove('hidden');
                box.style.maxHeight = box.getAttribute('data-max-height') + 'px';
            }
        })
        if (document.querySelector('.k1-filter__size-link'))
            document.querySelector('.k1-filter__size-link').classList.add('opened')
    },

    hideAllSizes: function () {
        let sizeBoxes = document.querySelectorAll('.k1-filter-size-box-js');

        let parentBoxes;
        if(sizeBoxes[0]){
            parentBoxes = sizeBoxes[0].closest('.k1-filter__checkboxes-body');
            if(parentBoxes.classList.contains('opened')){
                parentBoxes.classList.remove('opened');
            }
        }

        sizeBoxes.forEach(box => {
            if ( box.classList.contains('recommend') ) {
                box.classList.remove('hidden');
            } else {
                box.classList.remove('opened');
                box.classList.add('hidden');
            }

            box.style.maxHeight = box.getAttribute('data-min-height') + 'px';
        })
        if (document.querySelector('.k1-filter__size-link'))
            document.querySelector('.k1-filter__size-link').classList.remove('opened')
    },

    setMinHeightSizesBoxes: function () {
        let sizeBoxes = document.querySelectorAll('.k1-filter-size-box-js');
        sizeBoxes.forEach(box => {
            box.setAttribute('data-min-height', box.querySelector('.k1-filter-checkbox-js').clientHeight + 10);
            if (box.classList.contains('recommend')){
                box.setAttribute('data-min-height', box.querySelector('.k1-filter-checkbox-js').clientHeight + 20);
            }
        })
    },

    setMaxHeightSizesBoxes: function () {
        let sizeBoxes = document.querySelectorAll('.k1-filter-size-box-js');
        sizeBoxes.forEach(box => {
            box.setAttribute('data-max-height', 20);
        })
    },

    setCookieLife: function () {
        let limitDate = new Date();
        const months = 3;
        limitDate.setMonth(limitDate.getMonth() + months);
        return limitDate
    },

    toggleHomepageFilter: function (button) {
        console.log('button: ', button);
        if (button) {
            let form = button.closest('form');
            let boxes = form.querySelectorAll('.filter__form-row');
            let boxCurrent = button.closest('.filter__form-row');
            let chevron = boxCurrent.querySelector('.chevron-vertical');
            let list = boxCurrent.querySelector('.k1-toggle-box-js');
            let isOtherOpen = false;
            for (let i = 0; i < boxes.length; i++) {
                if (boxes[i] === boxCurrent) continue;
                if (boxes[i].classList.contains('opened')) isOtherOpen = true
                boxes[i].classList.remove('opened');
                boxes[i].querySelector('.chevron-vertical').classList.remove('opened');
                boxes[i].querySelector('.k1-toggle-box-js').style.maxHeight = 0;
            }

            boxCurrent.classList.toggle('opened');
            chevron.classList.toggle('opened');
            if (boxCurrent.classList.contains('opened')) {
                if (isOtherOpen) {
                    list.style.maxHeight = list.getAttribute('data-max-height') + 'px';

                } else {
                    list.style.maxHeight = list.getAttribute('data-max-height') + 'px';
                }

                if ( window.innerWidth < 768 ) {
                    window.NoScroll.show(true);
                }
            }
            else {
                list.style.maxHeight = 0;

                if ( window.innerWidth < 768 ) {
                    // document.querySelector('.header').classList.remove('hidden-index')
                    // document.querySelector('#wrapper').classList.remove('noscroll');
                    window.NoScroll.hide();

                }
            }

            document.querySelectorAll('.filter__form-row.opened').forEach(elem => {
                elem.addEventListener('mouseleave', function () {
                    boxCurrent.classList.remove('opened');
                    chevron.classList.remove('opened');
                    list.style.maxHeight = 0;
                })
            });
        }
    },

    closeHomepageFilter : function () {
        document.querySelectorAll('.filter__form-row.opened').forEach(elem => {
            // document.querySelector('.header').classList.remove('hidden-index')
            // document.querySelector('#wrapper').classList.remove('noscroll');
            window.NoScroll.hide();

            elem.classList.remove('opened')
        });

    },

    hideHomepageFilter: function () {
        let boxes = document.querySelectorAll('.filter__form-row');
        for (let i = 0; i < boxes.length; i++) {
            boxes[i].classList.remove('opened');
            boxes[i].querySelector('.chevron-vertical').classList.remove('opened');
            boxes[i].querySelector('.k1-toggle-box-js').style.maxHeight = 0;
        }

        if ( window.innerWidth < 768 ) {
            window.NoScroll.hide();

        }
    },

    selectHomepageFilter: function (elem) {
        const currentValue = elem.getAttribute('data-filter-value');
        const currentProperty = elem.closest('.filter__form-row').querySelector('.k1-toggle-box-chosen-js').getAttribute('data-property-name');
        const currentValueText = elem.textContent;
        const currentValueBlock = elem.closest('.filter__form-row').querySelector('.k1-toggle-box-chosen-js');
        currentValueBlock.setAttribute('data-property-value', currentValue);
        currentValueBlock.querySelector('span').textContent = currentValueText;

        elem.closest('.filter__form-list-inner').querySelectorAll('.filter__form-option').forEach( item => {
            if ( item.classList.contains('selected') ) item.classList.remove('selected');
        });
        elem.classList.add('selected');


        if (currentValue != 'none')
            currentValueBlock.classList.add('focus')
        else
            currentValueBlock.classList.remove('focus')

        switch (currentProperty) {
            case 'razmer':
                window.dremVars.homepageFilterArray[6] = 'razmer_matrasa-is-' + currentValue;
                break;
            case 'blok':
                window.dremVars.homepageFilterArray[4] = 'blok-is-' + currentValue;
                break;
            case 'zhestkost':
                window.dremVars.homepageFilterArray[3] = 'zhestkost-is-' + currentValue;
                break;
            case 'napolnitel':
                window.dremVars.homepageFilterArray[5] = 'napolnitel-is-' + currentValue;
                break;
        }
        window.dremVars.homepageFilterLink = '/' + window.dremVars.homepageFilterArray.filter(elem => {
            return elem
        }).join('/') + '/apply/';
        this.hideHomepageFilter();

    },

    homepageSetFilter: function () {
        if (window.dremVars.homepageFilterLink == ''){
            location.href = '/catalog/matrasy/'
        }else{
            location.href = window.dremVars.homepageFilterLink;
        }
        // console.log(window.dremVars.homepageFilterLink);
        window.dremVars.homepageFilterLink = '';
        window.dremVars.homepageFilterArray = ['catalog', 'matrasy', 'filter'];
    },

    init: function () {
        this.setMaxHeightSizesBoxes();
        this.setMinHeightSizesBoxes();
    }
};


window.addEventListener('DOMContentLoaded', () => {
    window.k1FilterGoods.init();
    self.k1FilterGoods.checkOpenSize();
});

window.addEventListener('click', e => {
    if (e.target.closest('.k1-filter-size-toggle-js'))
        self.k1FilterGoods.checkOpenSize(e.target.closest('.k1-filter-size-toggle-js'));

    if (e.target.closest('.k1-toggle-box-chosen-js'))
        self.k1FilterGoods.toggleHomepageFilter(e.target.closest('.k1-toggle-box-chosen-js'));

    if (e.target.closest('.homepage-filter-option-js'))
        self.k1FilterGoods.selectHomepageFilter(e.target.closest('.homepage-filter-option-js'));

    if (e.target.closest('.homepage-filter-link-js'))
        self.k1FilterGoods.toggleHomepageFilter(e.target.closest('.k1-toggle-box-chosen-js'));

    if (e.target.closest('.homepage-filter-link-js'))
        self.k1FilterGoods.homepageSetFilter();

    if ( window.innerWidth < 768 ){
        if (e.target.closest('.k1-toggle-box-js'))
            self.k1FilterGoods.closeHomepageFilter();
        // self.k1FilterGoods.toggleHomepageFilter(e.target.closest('.filter__form-row').querySelector('.k1-toggle-box-chosen-js'));
    }

});

/*
window.k1FilterGoods = {

    isChecked: function () {
        let ids = [];
        let inputs = document.querySelectorAll('.k1-filter-checkbox-js input[type="checkbox"]');
        inputs.forEach(item => {
            if (item.checked) ids.push(item.getAttribute('id'))
        });
        return ids;
    },

    setCheckedClass: function (arr) {

        if (!arr) return false;
        const inputsTitle = document.querySelector(".k1-filter__box.razmer .k1-filter__checkbox-title");
        let tmpArr = [];
        arr.forEach(elem => {
            let input = document.querySelector(`#${elem}`);
            input.closest('.k1-filter-checkbox-js').classList.add('selected');
            if (input.closest(".razmer")) tmpArr.push(input.nextElementSibling.textContent.trim())
        });
        if (!inputsTitle) return;


        if (tmpArr.length) {
            let selected = BX.create("SPAN", {
                props: {
                    className: "k1-filter__checkbox-title-selected"
                },
                text: tmpArr.join(", ")
            });
            inputsTitle.querySelector("span").textContent = "Размер : ";
            inputsTitle.append(selected)
        } else {
            inputsTitle.querySelector("span").textContent = "Размер";
            if (inputsTitle.querySelector(".k1-filter__checkbox-title-selected")) {
                inputsTitle.querySelector(".k1-filter__checkbox-title-selected").remove();
            }
        }

    },

    checkOpenSize: function (button) {
        if (button) button.classList.toggle('opened');
        window.dremVars.openedSizesFilter = !window.dremVars.openedSizesFilter;
        const isOpened = window.dremVars.openedSizesFilter;
        if (isOpened) {
            if (button) {
                button.querySelector('.k1-filter__size-toggle-text').textContent = 'Выбрать другой'
            }
            this.hideAllSizes();
        } else {
            if (button) {
                button.querySelector('.k1-filter__size-toggle-text').textContent = 'Скрыть'
            }
            this.showAllSizes();
        }
    },

    showAllSizes: function () {
        let sizeBoxes = document.querySelectorAll('.k1-filter-size-box-js');
        sizeBoxes.forEach(box => {
            box.classList.add('opened');
            box.style.maxHeight = box.getAttribute('data-max-height') + 'px';
        })
        if (document.querySelector('.k1-filter__size-link'))
            document.querySelector('.k1-filter__size-link').classList.add('opened')
    },

    hideAllSizes: function () {
        let sizeBoxes = document.querySelectorAll('.k1-filter-size-box-js');
        sizeBoxes.forEach(box => {
            box.classList.remove('opened');
            box.style.maxHeight = box.getAttribute('data-min-height') + 'px';
        })
        if (document.querySelector('.k1-filter__size-link'))
            document.querySelector('.k1-filter__size-link').classList.remove('opened')
    },

    setMinHeightSizesBoxes: function () {
        let sizeBoxes = document.querySelectorAll('.k1-filter-size-box-js');
        sizeBoxes.forEach(box => {
            box.setAttribute('data-min-height', box.querySelector('.k1-filter-checkbox-js').clientHeight + 10);
        })
    },

    setMaxHeightSizesBoxes: function () {
        let sizeBoxes = document.querySelectorAll('.k1-filter-size-box-js');
        sizeBoxes.forEach(box => {
            box.setAttribute('data-max-height', box.querySelector('.k1-filter__size-box-inner').clientHeight);
        })
    },

    setCookieLife: function () {
        let limitDate = new Date();
        const months = 3;
        limitDate.setMonth(limitDate.getMonth() + months);
        return limitDate
    },

    toggleHomepageFilter: function (button) {
        let form = button.closest('form');
        let boxes = form.querySelectorAll('.filter__form-row');
        let boxCurrent = button.closest('.filter__form-row');
        let chevron = boxCurrent.querySelector('.chevron-vertical');
        let list = boxCurrent.querySelector('.k1-toggle-box-js');
        let isOtherOpen = false;
        for (let i = 0; i < boxes.length; i++) {
            if (boxes[i] === boxCurrent) continue;
            if (boxes[i].classList.contains('opened')) isOtherOpen = true
            boxes[i].classList.remove('opened');
            boxes[i].querySelector('.chevron-vertical').classList.remove('opened');
            boxes[i].querySelector('.k1-toggle-box-js').style.maxHeight = 0;
        }

        boxCurrent.classList.toggle('opened');
        chevron.classList.toggle('opened');
        if (boxCurrent.classList.contains('opened')) {
            if (isOtherOpen) {
                // setTimeout(() => {
                list.style.maxHeight = list.getAttribute('data-max-height') + 'px';
                // }, 300)
            } else {
                list.style.maxHeight = list.getAttribute('data-max-height') + 'px';
            }

        } else {
            list.style.maxHeight = 0;
        }

        document.querySelectorAll('.filter__form-row.opened').forEach(elem => {
            elem.addEventListener('mouseleave', function () {
                // console.log('123')
                boxCurrent.classList.remove('opened');
                chevron.classList.remove('opened');
                list.style.maxHeight = 0;
            })
        });
    },

    hideHomepageFilter: function () {
        let boxes = document.querySelectorAll('.filter__form-row');
        for (let i = 0; i < boxes.length; i++) {
            boxes[i].classList.remove('opened');
            boxes[i].querySelector('.chevron-vertical').classList.remove('opened');
            boxes[i].querySelector('.k1-toggle-box-js').style.maxHeight = 0;
        }
    },

    selectHomepageFilter: function (elem) {
        const currentValue = elem.getAttribute('data-filter-value');
        const currentProperty = elem.closest('.filter__form-row').querySelector('.k1-toggle-box-chosen-js').getAttribute('data-property-name');
        const currentValueText = elem.textContent;
        const currentValueBlock = elem.closest('.filter__form-row').querySelector('.k1-toggle-box-chosen-js');
        currentValueBlock.setAttribute('data-property-value', currentValue);
        currentValueBlock.querySelector('span').textContent = currentValueText;

        elem.closest('.filter__form-list-inner').querySelectorAll('.filter__form-option').forEach( item => {
            if ( item.classList.contains('selected') ) item.classList.remove('selected');
        });
        elem.classList.add('selected');


        if (currentValue != 'none')
            currentValueBlock.classList.add('focus')
        else
            currentValueBlock.classList.remove('focus')

        switch (currentProperty) {
            case 'razmer':
                window.dremVars.homepageFilterArray[6] = 'razmer-is-' + currentValue;
                break;
            case 'blok':
                window.dremVars.homepageFilterArray[4] = 'blok-is-' + currentValue;
                break;
            case 'zhestkost':
                window.dremVars.homepageFilterArray[3] = 'zhestkost-is-' + currentValue;
                break;
            case 'napolnitel':
                window.dremVars.homepageFilterArray[5] = 'napolnitel-is-' + currentValue;
                break;
        }
        window.dremVars.homepageFilterLink = '/' + window.dremVars.homepageFilterArray.filter(elem => {
            return elem
        }).join('/') + '/apply/';
        this.hideHomepageFilter();

    },

    homepageSetFilter: function () {
        if (window.dremVars.homepageFilterLink == ''){
            location.href = '/catalog/matrasy/'
        }else{
            location.href = window.dremVars.homepageFilterLink;
        }
        // console.log(window.dremVars.homepageFilterLink);
        window.dremVars.homepageFilterLink = '';
        window.dremVars.homepageFilterArray = ['catalog', 'matrasy', 'filter'];
    },

    init: function () {
        this.setMaxHeightSizesBoxes();
        this.setMinHeightSizesBoxes();
    }
};


*/